var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriterionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#FFC000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3789_99434)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3789_99434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3339 39.4597H34.6678C37.2671 39.4597 38.5603 38.1413 38.5603 35.5297V24.1291C38.5603 22.5091 38.3846 21.8063 37.3802 20.7766L30.4491 13.7331C29.4955 12.7533 28.7166 12.54 27.298 12.54H21.3339C18.7475 12.54 17.4414 13.8708 17.4414 16.4829V35.5297C17.4414 38.1536 18.7475 39.4597 21.3339 39.4597ZM21.4341 37.4384C20.1409 37.4384 19.4627 36.7474 19.4627 35.4922V16.5204C19.4627 15.2775 20.1409 14.5613 21.4469 14.5613H27.0216V21.8566C27.0216 23.4386 27.8252 24.217 29.3819 24.217H36.5391V35.4922C36.5391 36.7474 35.8732 37.4384 34.5677 37.4384H21.4341ZM29.608 22.3206C29.1184 22.3206 28.9169 22.1202 28.9169 21.6177V14.9508L36.1491 22.3211L29.608 22.3206Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3789_99434"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 30,
    height: 30,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3789_99434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(13 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriterionIcon2);
export default __webpack_public_path__ + "static/media/criterion-icon-2.9acb5838eb2b8ad20a9ac664afa58e35.svg";
export { ForwardRef as ReactComponent };